import React, {  useEffect, useContext } from 'react';
import { AddressContext } from '../contexts/AddressContext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { LocaleBg } from '../Shared/PrimeReactCallendarConfig';
import { ParameterContext } from '../contexts/ParameterContext';
import { AuthContext } from '../contexts/AuthContext';
import { Checkbox } from 'primereact/checkbox';


export default function AddressChildren({ formData, handleChange, isDropdownOpen, toggleDropDown, isMunicipality, isEdit }) {
    const { streets, searchAddressInputChange, searchAddressInforamtion, addressInfo, getResidences, residences, addressResidence } = useContext(AddressContext);
    const { parameters } = useContext(ParameterContext)
    const { user } = useContext(AuthContext);

    const mainRegForm = parameters.nomParameters && parameters.nomParameters.length > 0 && parameters.nomParameters.find(x => x.param_name == 'MAIN_REGISTER_FORM');
    const dirDisableChildData = parameters.nomParameters && parameters.nomParameters.length > 0 && parameters.nomParameters.find(x => x.param_name == 'DIR_DISABLE_CIHLD_DATA');
    const automaticTimeLived = parameters.nomParameters && parameters.nomParameters.length > 0 && parameters.nomParameters.find(x => x.param_name == 'AUTOMATIC_TIME_LIVED');
    const dontHaveAddressInAddressResidenceParam = parameters.nomParameters.find(x => x.param_name == 'DONT_HAVE_DATES_IN_ADDRESS_RESIDENCE');

    //Check if system is cofigured to desable address fields when user is director and child is in the Nom Address Residence Table !!!!
    const mustDisableAddressFields = user.role == 'Director' && dirDisableChildData.value == 1 && addressResidence.length > 0
    const mustDisableDataResidenceFields = (user.role == 'Director' && automaticTimeLived.value == 1 && addressResidence.length > 0)
        || (user.role == 'Director' && automaticTimeLived.value == 0 && addressResidence.length > 0 && dirDisableChildData.value != 0 && dontHaveAddressInAddressResidenceParam?.value != 1)
    useEffect(() => {
        if (mainRegForm.value == 1) {
            setTimeout(() => {
                getResidences();
                searchAddressInputChange('a')
            }, 500)
        }
       
    }, [])
   
    const handleSearchChange = (event) => {
        const inputValue = event.originalEvent.target.value;
        if (inputValue === '') {
            searchAddressInputChange('а');
        } else {
            searchAddressInputChange(inputValue);
        }
    };

    const selectedStreetTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div>{option.name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const streetOptionTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <div>{option.name}</div>
            </div>
        );
    };

    const selectedAddressInfoTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div>
                        {option.addressNumber}
                    </div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const addressInfoOptionTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <div>
                    {option.addressNumber}
                </div>
            </div>
        );
    };
    
    return (
        <>
            <div className="">

                <div className="htext_padr">Постоянен адрес на детето</div>

                <div className="children_data ">
                    {user.role == 'Municipality' &&
                        <div className="d-flex flex-wrap mb-2">

                            <div className="labels_rb w-15 w-25-l w-45-mob" id="basic-addon1">Извън общината</div>
                            <div className="labels_rb w-15" id="basic-addon1">
                                <Checkbox
                                    inputId="lnccid"
                                    name='dontHavePermanentAddress'
                                    onChange={handleChange}
                                    checked={formData.dontHavePermanentAddress}
                                />
                            </div>

                        </div>
                    }

                    <div className="w-100 d-flex gap-3 flex-wrap flex-wrap-mob">
                        {user.role == 'Municipality' || isMunicipality || formData.dontHavePermanentAddress ? null
                            : <div className="flex-col flex-wrap col_city w-100-mob w-49">
                                <div className="labels_rb" id="basic-addon1">Град*</div>
                                <div className="labels_rb w-100" id="basic-addon1">
                                    <select disabled={mustDisableAddressFields} type="text" name="permanentChildCity" className="form-control round_buttons w-100" onChange={handleChange} value={formData.permanentChildCity}>
                                        <option value="" style={{ display: 'none' }}>
                                            Изберете град*
                                        </option>
                                        {residences && residences.map(residence => (
                                            <option key={residence.codeNm} value={residence.nameNm}>
                                                {residence.nameNm}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>}

                        {user.role == 'Municipality' || isMunicipality
                            ? <div className="flex-col flex-wrap col_adr w-65 w-70-l w-100-mob">
                                <div className="labels_rb w-100" id="basic-addon1">Постоянен адрес на детето*:</div>
                                <input type="text" name='permanentAddress' disabled={mustDisableAddressFields} className="form-control round_buttons w-100" value={formData.permanentAddress} onChange={handleChange} placeholder={`${formData.dontHavePermanentAddress ? 'Постоянен адрес' : 'Полето трябва да е изписано на кирилица'}`} />
                            </div>
                            : <>
                                {formData.dontHavePermanentAddress
                                    ? <input type="text" disabled={mustDisableAddressFields} name='permanentAddress' className="form-control round_buttons w-100" value={formData.permanentAddress} onChange={handleChange} placeholder={`${formData.dontHavePermanentAddress ? 'Постоянен адрес' : 'Полето трябва да е изписано на кирилица'}`} />
                                    : <>
                                        <div className="flex-col flex-wrap col_adr w-100-mob w-49">
                                            <div className="labels_rb w-100 w-100-mob" id="basic-addon1">Квартал / Име на улица*:</div>
                                            {isDropdownOpen.isPermanentAddress
                                                ? <Dropdown
                                                    name="permanentAddress"
                                                    value={formData.permanentAddress}
                                                    className="w-100 prime-dropdown-heigth w-100-mob"
                                                    options={streets}
                                                    optionLabel="name"
                                                    filter
                                                    valueTemplate={selectedStreetTemplate}
                                                    itemTemplate={streetOptionTemplate}
                                                    onChange={handleChange}
                                                    onFocus={(e) => searchAddressInputChange('а')}
                                                    onFilter={(e) => handleSearchChange(e)}
                                                    disabled={mustDisableAddressFields}
                                                />
                                                : <input type="text" disabled={mustDisableAddressFields} className="form-control round_buttons" value={formData.permanentAddress ? formData.permanentAddress.name : ''} onFocus={(e) => toggleDropDown(false)} placeholder="Изберете име на улица" />
                                            }
                                        </div>
                                        {formData.permanentAddress && formData.permanentAddress.id !== '' &&
                                            <div className="flex-col flex-wrap col_adr fade w-49">
                                                <div className="labels_rb w-100" id="basic-addon1">Блок / номер* :</div>
                                                {isDropdownOpen.isPermanentAddress
                                                    ? <Dropdown
                                                        name="permanentAddressInfo"
                                                        value={formData.permanentAddressInfo}
                                                        className="w-100 prime-dropdown-heigth"
                                                        options={addressInfo}
                                                        optionLabel="addressNumber"
                                                        placeholder="Изберете номер на улица"
                                                        filter
                                                        valueTemplate={selectedAddressInfoTemplate}
                                                        itemTemplate={addressInfoOptionTemplate}
                                                        onChange={handleChange}
                                                        onFocus={(e) => searchAddressInforamtion(formData.permanentAddress.id, formData.permanentAddress.residenceId)}
                                                        disabled={mustDisableAddressFields}
                                                    />
                                                    : <input type="text" disabled={mustDisableAddressFields} className="form-control round_buttons" value={formData.permanentAddressInfo ? formData.permanentAddressInfo.addressNumber : ''} onFocus={(e) => toggleDropDown(false)} placeholder="Изберете номер на улица" />
                                                }
                                            </div>
                                        }

                                    </>

                                }
                            </>
                        }

                        {!formData.dontHavePermanentAddress &&
                            <div className={`${user.role == 'Municipality' || isMunicipality ? 'w-30' : 'w-49'} flex-col flex-wrap col_city  w-30-l w-100-mob`}>

                                <div className="labels_rb" id="basic-addon1">Дата*</div>
                                <div className="labels_rb w-100 " id="basic-addon1">
                                    <Calendar
                                        showButtonBar
                                        locale='bg'
                                        className="prime-dropdown-heigth w-100-mob w-100"
                                        name="permanentAddressDate"
                                        value={formData.permanentAddressDate || null}
                                        onChange={handleChange}
                                        showIcon
                                        disabled={mustDisableDataResidenceFields}
                                    />
                                </div>

                            </div>

                        }


                    </div>

                </div>

            </div>
            <div className="" >

                <div className="htext_padr">Настоящ адрес на детето</div>

                <div className="children_data">
                    {user.role == 'Municipality' &&
                        <div className="d-flex flex-wrap mb-2">

                            <div className="labels_rb w-15 w-25-l w-45-mob" id="basic-addon1">Извън общината</div>
                            <div className="labels_rb w-15" id="basic-addon1">
                                <Checkbox
                                    inputId="lnccid"
                                    name='dontHaveCurrentAddress'
                                    onChange={handleChange}
                                    checked={formData.dontHaveCurrentAddress}
                                />
                            </div>

                        </div>
                    }

                    <div className="w-100 d-flex gap-3 flex-wrap flex-wrap-mob">

                        {user.role == 'Municipality' || isMunicipality ? null
                            : <div className="flex-col flex-wrap col_city w-100-mob w-49">
                                <div className="labels_rb" id="basic-addon1">Град*</div>
                                <div className="labels_rb w-100" id="basic-addon1">
                                    <select type="text" disabled={mustDisableAddressFields} name="currentChildCity" className="form-control round_buttons" value={formData.currentChildCity} onChange={handleChange}>
                                        <option value="" style={{ display: 'none' }}>
                                            Изберете град*
                                        </option>
                                        {residences && residences.map(residence => (
                                            <option key={residence.codeNm} value={residence.nameNm}>
                                                {residence.nameNm}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        }


                        {user.role == 'Municipality' || isMunicipality
                            ? <div className="flex-col flex-wrap col_adr w-65 w-70-l w-100-mob">
                                <div className="labels_rb w-100" id="basic-addon1">Настоящ адрес на детето*:</div>
                                <input type="text" name='currentAddress' disabled={mustDisableAddressFields} className="form-control round_buttons w-100" value={formData.currentAddress} onChange={handleChange} placeholder={`${formData.dontHaveCurrentAddress ? 'Постоянен адрес' : 'Полето трябва да е изписано на кирилица'}`} />
                            </div>
                            : <>
                                <div className="flex-col flex-wrap col_adr w-100-mob w-49">
                                    <div className="labels_rb w-100" id="basic-addon1">Квартал / Име на улица*:</div>
                                    {isDropdownOpen.isCurrentAddress
                                        ? < Dropdown
                                            name="currentAddress"
                                            value={formData.currentAddress}
                                            className="w-100 prime-dropdown-heigth"
                                            options={streets}
                                            optionLabel="name"
                                            filter
                                            valueTemplate={selectedStreetTemplate}
                                            itemTemplate={streetOptionTemplate}
                                            onChange={handleChange}
                                            onFocus={(e) => searchAddressInputChange('а')}
                                            onFilter={(e) => handleSearchChange(e)}
                                            disabled={mustDisableAddressFields}
                                        />
                                        : <input type="text" disabled={mustDisableAddressFields} className="form-control round_buttons" value={formData.currentAddress ? formData.currentAddress.name : ""} onFocus={(e) => toggleDropDown(true)} placeholder="Изберете име на улица" />
                                    }
                                </div>
                                {formData.currentAddress && formData.currentAddress.id !== '' &&
                                    <div className="flex-col flex-wrap col_adr fade w-100-mob w-49">
                                        <div className="labels_rb w-100" id="basic-addon1">Блок / номер* :</div>
                                        {isDropdownOpen.isCurrentAddress
                                            ? <Dropdown
                                                name="currentAddressInfo"
                                                value={formData.currentAddressInfo}
                                                className="w-100 prime-dropdown-heigth"
                                                options={addressInfo}
                                                optionLabel="addressNumber"
                                                filter
                                                valueTemplate={selectedAddressInfoTemplate}
                                                itemTemplate={addressInfoOptionTemplate}
                                                onChange={handleChange}
                                                onFocus={(e) => searchAddressInforamtion(formData.currentAddress.id, formData.currentAddress.residenceId)}
                                                disabled={mustDisableAddressFields}
                                            />
                                            : <input type="text" disabled={mustDisableAddressFields} className="form-control round_buttons" value={formData.currentAddressInfo ? formData.currentAddressInfo.addressNumber : ''} onFocus={(e) => toggleDropDown(true)} placeholder="Изберете номер на улица" />
                                        }
                                    </div>
                                }
                            </>
                        }

                        {!formData.dontHaveCurrentAddress &&
                            <div className={`${user.role == 'Municipality' || isMunicipality ? 'w-30' : 'w-49'} flex-col flex-wrap col_city  w-30-l w-100-mob`}>

                                <div className="labels_rb" id="basic-addon1">Дата*</div>
                                <div className="labels_rb w-100" id="basic-addon1">
                                    <Calendar
                                        showButtonBar
                                        locale='bg'
                                        className="prime-dropdown-heigth w-100 w-100-mob"
                                        name="currentAddressDate"
                                        value={formData.currentAddressDate || null}
                                        onChange={handleChange}
                                        showIcon
                                        disabled={mustDisableDataResidenceFields}
                                    />
                                </div>

                            </div>
                        }

                    </div>

                </div>

            </div>
        </>
    );
}

